/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BilletInvoiceResponseViewModel } from "../types/BilletInvoiceResponseViewModel.ts";

export const billetInvoiceResponseViewModelSchema = z.object({
  issAliquot: z.number().nullish(),
  serviceDescription: z.string().nullish(),
  cnae: z.string().nullish(),
  municipalActivityClassification: z.string().nullish(),
}) as unknown as ToZod<BilletInvoiceResponseViewModel>;
